module.exports = __webpack_public_path__ + "img/collection-weddingRingsStarrySky.27fb92a.jpg";